package io.horion.cv.api.datasource.motivation

enum class ModelLetter(name: String) {
    SIMPLE("SIMPLE"),
    MODERN("MODERN"),
    PROFESSIONAL("PROFESSIONAL"),
    ADVANCE("ADVANCE"),
    ENGLISH("ENGLISH"),
    FRENCH("FRENCH"),
    OTHER("OTHER")
}